<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item to="/template/list">模板管理</el-breadcrumb-item>
        <el-breadcrumb-item>添加模板</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">模板管理</h2>
        </div>
      </div>
    </div>
    <div class="card"
         style="margin-top: 20px;">
      <div class="main">
        <div class="form">
          <el-form class="search-wrap"
                   ref="formRules"
                   :model="dataForm"
                   :rules="rules"
                   label-width="150px"
                   label-position="left">
            <el-form-item label="模板类型"
                          prop="TemplateType">
              <el-radio-group v-model="dataForm.TemplateType">
                <el-radio :label="2">推广短信（0.055元/条）</el-radio>
                <el-radio :label="1">通知短信（0.045元/条）</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="模板名称"
                          prop="TemplateName">

              <el-input v-model="dataForm.TemplateName"
                        placeholder="请输入名称，不超过30个字符"
                        style="width: 582px;"
                        show-word-limit></el-input>
            </el-form-item>
            <el-form-item label="模板内容"
                          prop="TemplateContent">
              <el-input v-model="dataForm.TemplateContent"
                        type="textarea"
                        :rows="5"
                        placeholder="请输入名称，不超过30个字符"
                        style="width: 582px;"
                        :maxlength="500"
                        show-word-limit
                        id="textarea"></el-input>
              <div class="link-wrap">
                可点击右侧变量进行添加：
                <el-link type="primary"
                         :underline="false"
                         @click="insertVar(item.variable_str)"
                         v-for="(item,index) in variablelist"
                         :key="index">#{{item.variable_name}}#</el-link>
              </div>
            </el-form-item>
          </el-form>
          <div class="line"></div>
          <div class="btn-wrap">
            <el-button type="primary"
                       @click="submit('formRules')">添加</el-button>
            <el-button @click="handleClose()">取消</el-button>
          </div>
        </div>
        <div class="preview">
          <div class="preview-content">
            <div class="pop">
              <span> {{ dataForm.TemplateContent }}</span>
            </div>
            <div class="tips">计费说明：当前约为<span>{{ dataForm.TemplateContent?dataForm.TemplateContent.length:0 }}</span>字，预计发送条数约为<span>{{ 1 }}</span>条（实际发送时，签名，变量长度回影响总字数）。</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import {
  smsSignlist,
  smsTemplatevariablelist,
  smsTemplateCreate,
} from '@/api/operation'
export default {
  components: {},
  data() {
    return {
      dataForm: {
        TemplateContent: '',
      },
      rules: {
        TemplateType: [
          { required: true, message: '请选择模板类型', trigger: 'blur' },
        ],
        TemplateName: [
          { required: true, message: '请选择模板名称', trigger: 'blur' },
        ],
        TemplateContent: [
          { required: true, message: '请选择模板内容', trigger: 'change' },
        ],
      },
      signList: [],
      variablelist: [],
    }
  },
  created() {
    this.fetchVariableList()
  },
  methods: {
    fetchVariableList() {
      smsTemplatevariablelist({ isPging: 0 }).then((res) => {
        console.log(res)
        this.variablelist = res.list
      })
    },
    insertVar(variable) {
      let el = document.getElementById('textarea')
      let cursurPosition = -1
      if (el.selectionStart >= 0) {
        cursurPosition = el.selectionStart
      } else {
        let range = document.selection.createRange()
        cursurPosition = range.text.length
      }
      this.dataForm.TemplateContent =
        this.dataForm.TemplateContent.slice(0, cursurPosition) +
        '${' +
        variable +
        '}' +
        this.dataForm.TemplateContent.slice(cursurPosition)
    },
    handleClose() {
      this.$router.go(-1)
    },
    submit(rules) {
      this.$refs[rules].validate((valid) => {
        if (valid) {
          const data = {
            TemplateType: this.dataForm.TemplateType,
            TemplateName: this.dataForm.TemplateName,
            TemplateContent: this.dataForm.TemplateContent,
          }

          smsTemplateCreate(data).then((res) => {
            console.log(res)

            if (res.Code == 'OK') {
              this.handleClose()
              this.$message.success('创建成功')
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>
  
  <style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
    .main {
      height: 828px;
      display: flex;
      padding-top: 24px;

      .form {
        flex: 1;
        .link-wrap {
          margin-top: 8px;
          font-size: 14px;
          color: #999;
          .el-link {
            margin-right: 16px;
          }
        }
        .line {
          width: 730px;
          height: 1px;
          background: #eeeeee;
          border-radius: 0px 0px 0px 0px;
          opacity: 1;
        }
        .btn-wrap {
          margin-top: 16px;
        }
      }
      .preview {
        flex: 1;
        display: flex;
        justify-content: center;
        .preview-content {
          width: 330px;
          height: 546px;
          background-image: url('https://upload.kaoyanbox.net/5b02efcfefeb534cae1ffe1ab8a88da0.png');
          background-size: 100% 100%;
          background-repeat: no-repeat;

          .pop {
            width: 224px;
            background: #e9e9eb;
            opacity: 1;
            min-height: 80px;
            border-radius: 16px;
            margin-top: 118px;
            padding: 9px 12px;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            margin-left: 43px;
            span {
              word-wrap: break-word;
            }
          }
          .tips {
            width: 261px;
            margin: 0 auto;
            margin-top: 40px;
            padding: 9px 12px;
            font-size: 14px;
            color: #666666;
            line-height: 22px;
            span {
              color: #e34d59;
              margin: 0px 4px;
            }
          }
        }
      }
    }
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }
}
</style>
  